export interface HeaderSpacerState {
  headerSpacer: string | null;
}

export const initialHeaderSpacerState: HeaderSpacerState = {
  headerSpacer: null,
};
